import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    yRight,
    partSumpTrajectory,
    popupInformation,
    defaultDatalabelsAlign,
    defaultDatalabelsAnchor,
    defaultDatalabelsFontWeight,
    defaultTicksCustomValue,
} from "../../../utils";

const FemmesEntreprisesTransport = {
    checked: false,
    titleSideBar: "Mujeres empleadas en las empresas de transporte",
    titleIndicator:
        "SUMP Trajectory Content.charts.FemmesEntreprisesTransport.title",
    popupInformation: {
        status: "false",
        text: popupInformation[partSumpTrajectory][
            "femmesEntreprisesTransport"
        ],
    },
    keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
    },
    charts: [
        {
            typeChart: "bar",
            typeLabels: "years", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "year", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "true",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: true,
            indexAxis: "x", // x or y
            heightChart: "340",
            widthChart: "400",
            scales: {
                x: {
                    type: "category",
                    display: true,
                    stacked: false,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    min: null,
                    beginAtZero: false,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                y: {
                    type: "linear",
                    display: true,
                    stacked: false,
                    titleDisplay: true,
                    titleText:
                        "SUMP Trajectory Content.charts.FemmesEntreprisesTransport.axis.titleY",
                    gridDisplay: true,
                    beginAtZero: true,
                    max: 100,
                    ticks: {
                        display: true,
                        value: {
                            prefix: "",
                            suffix: "",
                        },
                    },
                },
                yRight: yRight,
            },
            annotationsProperties: {
                annotation1: {
                    type: "line",
                    xMin: undefined,
                    xMax: undefined,
                    yMin: 10,
                    yMax: 10,
                    borderColor: "rgb(228, 158, 221)",
                    borderDash: [7, 7],
                    borderDashOffset: 0,
                    borderWidth: 3,
                },
                annotation2: {
                    type: "line",
                    xMin: undefined,
                    xMax: undefined,
                    yMin: 20,
                    yMax: 20,
                    borderColor: "rgb(70, 177, 225)",
                    borderDash: [7, 7],
                    borderDashOffset: 0,
                    borderWidth: 3,
                },
            },
            keyFigure: {
                typeUpdate: "geographical_area", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },
            datasets: [
                {
                    type: "line",
                    label: "SUMP Trajectory Content.charts.FemmesEntreprisesTransport.legend.Valeur cible 2034",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=femmes_entreprises_transport&trend=projection&chart=femmes_entreprises_transport_valeur_cible_2034&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_target_value_2034_femmes_entreprises_transport"
                        ].backgroundColor["0"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_target_value_2034_femmes_entreprises_transport"
                        ].borderColor["0"],
                    borderWidth: 4,
                    borderDash: [7, 7],
                    pointStyle: "circle",
                    pointRadius: 0,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: 1,
                    categoryPercentage: 1,
                    datalabelsProperties: {
                        display: false,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "",
                        },
                    },
                },
                {
                    type: "line",
                    label: "SUMP Trajectory Content.charts.FemmesEntreprisesTransport.legend.Valeur cible 2044",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=femmes_entreprises_transport&trend=projection&chart=femmes_entreprises_transport_valeur_cible_2044&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_target_value_2044_femmes_entreprises_transport"
                        ].backgroundColor["0"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_target_value_2044_femmes_entreprises_transport"
                        ].borderColor["0"],
                    borderWidth: 4,
                    borderDash: [7, 7],
                    pointStyle: "circle",
                    pointRadius: 0,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: 1,
                    categoryPercentage: 1,
                    datalabelsProperties: {
                        display: false,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "",
                        },
                    },
                },
                {
                    type: "bar",
                    label: "SUMP Trajectory Content.charts.FemmesEntreprisesTransport.legend.Nombre",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=sump-trajectory&type_label=cusco_years&indicator=femmes_entreprises_transport&trend=projection&chart=femmes_entreprises_transport&chart_data=True&indicator_key_figure=False&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes[
                            "trajectory_target_value_2024_femmes_entreprises_transport"
                        ].backgroundColor["0"],
                    borderColor:
                        configChartsColorPalettes[
                            "trajectory_target_value_2024_femmes_entreprises_transport"
                        ].borderColor["0"],
                    borderWidth: 2,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 3,
                    tooltipUnit: "",
                    barPercentage: 0.8,
                    categoryPercentage: 0.4,
                    datalabelsProperties: {
                        display: false,
                        anchor: defaultDatalabelsAnchor,
                        align: defaultDatalabelsAlign,
                        font: {
                            weight: defaultDatalabelsFontWeight,
                        },
                        value: {
                            prefix: "",
                            suffix: "",
                            separator: "",
                        },
                    },
                },
            ],
        },
    ],
};

export default FemmesEntreprisesTransport;
